<template>
  <div>
    <keep-alive>
	<router-view v-if="$route.meta.keepAlive"></router-view>
	</keep-alive>
<router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'blank'
}
</script>



// WEBPACK FOOTER //
// src/layout/blank.vue